import $ from 'jquery';
import { register } from './../exports/theme-sections';
import parallaxImage from './../exports/parallaxImage';
import { gridSwatches } from './../exports/swatches';
import popoutSection from './../features/popout';
import collectionFiltersSidebar from './../features/collection-filters-sidebar';
import toggleGrid from './../features/toggleGrid';

const collectionSection = {
  onLoad() {
    const sortEnabled = (this.container.getAttribute('data-sort') !== 'false');
    if (sortEnabled) {
      this.sortingClick();
    }
    var swatches = this.container.querySelectorAll('[data-grid-swatches]');
    for (var i = 0; i < swatches.length; i++) {
      gridSwatches(swatches[i]);
    }
    this._removeUnusableFilters();
  },
  sortingClick: function() {
    Shopify.queryParams = {};
    const location = window.location;
    if (location.search.length && location.search.indexOf('sort_by')) {
      for (
        var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&');
        i < aCouples.length;
        i++
      ) {
        aKeyValue = aCouples[i].split('=');
        if (aKeyValue.length > 1) {
          Shopify.queryParams[
            decodeURIComponent(aKeyValue[0])
          ] = decodeURIComponent(aKeyValue[1]);
        }
      }
    }
    $('[data-sort-link]', this.$container).click(function(evt) {
      evt.preventDefault();
      Shopify.queryParams.sort_by = $(this).data('value');
      location.search = $.param(Shopify.queryParams);
    });
  },
  _removeUnusableFilters() {
    $('.collection-nav--grouped', this.$container).each(function() {
      var $visibleChildren = $(this).children().filter('.link--add');
      var $activeChildren = $(this).children().filter('.link--remove');
      if ($visibleChildren.length == 0 && $activeChildren.length == 0) {
        $(this).hide();
        $(this)
          .prev('.sidebar__heading')
          .hide();
      }
      if ($activeChildren.length > 0) {
        $(this)
          .prev('.sidebar__heading')
          .addClass('has-filters');
      } else {
        $(this)
          .prev('.sidebar__heading')
          .find('.link--clear')
          .children()
          .unwrap();
      }
    });
  },
};

register('collection', [collectionSection, parallaxImage, popoutSection, collectionFiltersSidebar, toggleGrid]);
